import React from "react"
import PropTypes from "prop-types"

// material-ui
import BottomNavigation from "@material-ui/core/BottomNavigation"
import BottomNavigationAction from "@material-ui/core/BottomNavigationAction"
import withStyles from "@material-ui/core/styles/withStyles"

// icons
import { MdKeyboardArrowLeft,  MdKeyboardArrowRight } from "react-icons/md"

import styles from "./styles"

export const BottomControls = ({
    classes, onLeftClick, onRightClick, ...rest
}) => (
    <BottomNavigation className={classes.root} {...rest}>
        <BottomNavigationAction className={classes.control} icon={<MdKeyboardArrowLeft size={24} />} onClick={onLeftClick} />
        <BottomNavigationAction className={classes.control} icon={<MdKeyboardArrowRight size={24} />} onClick={onRightClick} />
    </BottomNavigation>
)

BottomControls.propTypes = {
    onLeftClick: PropTypes.func,
    onRightClick: PropTypes.func,
}

BottomControls.defaultProps = {
    onLeftClick: () => null,
    onRightClick: () => null,
}

export default withStyles(styles)(BottomControls)



// WEBPACK FOOTER //
// ./src/lib/components/BottomControls/index.js